// Pure logic behind the "Strategie schärfen" banner and form (no React, unit-tested from server/__tests__).

export type StrategyStatus =
  | { state: "none" | "running" | "failed" | "unavailable"; pillars?: string[] }
  | { state: "ready"; pillars: string[]; refinement: "preliminary" | "refined"; refining: boolean };

export type OnboardingStatusResponse = { strategy?: StrategyStatus; strategyByTeam?: boolean };

/** "Später" hides the banner for this long, then it comes back. */
export const REFINE_SNOOZE_MS = 3 * 24 * 60 * 60 * 1000;

/** Which banner to show; null = none. Only a preliminary strategy asks to be sharpened, and never for a
 *  hotel: its strategy comes from the team (strategyByTeam, Mike 2026-10-08). */
export function refineBannerMode(status: OnboardingStatusResponse | undefined): "refine" | "refining" | null {
  if (status?.strategyByTeam) return null;
  const s = status?.strategy;
  if (!s || s.state !== "ready" || s.refinement !== "preliminary") return null;
  return s.refining ? "refining" : "refine";
}

/** The banner shows unless the hotel snoozed it and the snooze has not run out. "refining" ignores the snooze. */
export function isRefineBannerVisible(
  mode: "refine" | "refining" | null,
  snoozedUntil: number,
  now: number,
): boolean {
  if (!mode) return false;
  return mode === "refining" || snoozedUntil <= now;
}

/** The three answers the strategy prompt needs; the server takes 1 to 2000 characters each. */
export const REFINE_REQUIRED = ["customerMainProblem", "customerEnemy", "contrarianPov"] as const;

/** Response of POST /api/strategy/trigger-generation and /generate. teamRequest = hotel, routed to the team. */
export type StrategyRequestResponse = { ok: boolean; teamRequest?: boolean; message?: string };

export function missingRefineAnswers(a: Record<(typeof REFINE_REQUIRED)[number], string>): boolean {
  return REFINE_REQUIRED.some((k) => a[k].trim() === "");
}
